'use strict'

import BookingReward from '@ui/Accommodation/Offer/BookingReward/component'

export default function (): void {
  document.querySelectorAll<HTMLElement>('.accommodation-offer-booking-reward').forEach((el) => {
    BookingReward(el)
  })
}
